export default "__VITE_ASSET__D7rMF$ON__"